import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICaseStatusTypesService } from "services/CaseStatusTypesService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  CaseStatusTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const caseStatusTypeSelectSlice = createSlice({
  name: "caseStatusTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCaseStatusTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCaseStatusTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getCaseStatusTypeSelectModels.fulfilled, (state, action) => {
        state.CaseStatusTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getCaseStatusTypeSelectModels = createAsyncThunk("CaseStatusTypeSelect/GetSelectModels", async () => {
  const caseStatusTypesService = container.get<ICaseStatusTypesService>(SERVICE_TYPES.CaseStatusTypesService);
  return await caseStatusTypesService.getCaseStatusTypeSelectModels();
});

export const selectCaseStatusTypeSelectModels = (state: RootState) => {
  return state.caseStatusTypesSelect.CaseStatusTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.caseStatusTypesSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.caseStatusTypesSelect.LastUpdateTime;
};

export default caseStatusTypeSelectSlice.reducer;
